let zoomRadius = {
  x: parseInt(25 / 2),
  y: parseInt(25 / 2),
};
const state = {
  zoomRadius: zoomRadius,
  showZoomIn: false,
  zoomInActive: false,
  area: {
    x: 0,
    y: 0,
  },
  // format multibooka dla kl 4
  // zoomInCenterfoldWidth: 3624,
  // zoomInCenterfoldHeight: 2150

  // format multibooka dla kl7 (plastyka ,muzyka)
  zoomInCenterfoldWidth: 2792,
  zoomInCenterfoldHeight: 1977,
};

const mutations = {
  ZOOMIN_CENTERFOLD_CHANGE(state, zoomCenterfold) {
    state.zoomInCenterfoldWidth = zoomCenterfold.width;
    state.zoomInCenterfoldHeight = zoomCenterfold.height;
  },
  ZOOMIN_ACTIVE(state, zoomInActive) {
    state.zoomInActive = zoomInActive;
  },
  SHOW_ZOOMIN(state, showZoomIn) {
    state.showZoomIn = showZoomIn;
  },
  SET_AREA(state, area) {
    state.area = area;
  },
};

const actions = {
  someAsyncTask({ commit }) {
    // do something async
    commit('TEST');
  },
};

const getters = {
  showZoomIn: (state) => {
    return state.showZoomIn;
  },
  zoomInActive: (state) => {
    return state.zoomInActive;
  },
  area: (state) => {
    return state.area;
  },
  zoomRadius: (state) => {
    return state.zoomRadius;
  },
  zoomInCenterfoldWidth: (state) => {
    return state.zoomInCenterfoldWidth;
  },
  zoomInCenterfoldHeight: (state) => {
    return state.zoomInCenterfoldHeight;
  },
};
export default {
  state,
  mutations,
  actions,
  getters,
};
